// 品質管理ページスクロールに応じて動画が再生される
document.addEventListener('DOMContentLoaded', () => {
    // クラス名で要素を取得
    const sections = document.querySelectorAll('.quality-page__list-img');
    const videos = document.querySelectorAll('.video');
  
    // 現在再生中の動画を追跡
    let currentPlaying = null;
  
    // 初期設定: 全ての動画を停止
    videos.forEach(video => {
      video.pause();
    });
  
    // スクロールイベント監視
    window.addEventListener('scroll', () => {
      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
  
        if (isInView) {
          const video = videos[index];
  
          // 現在の動画が異なる場合のみ再生
          if (currentPlaying !== video) {
            // 前の動画を停止
            if (currentPlaying) {
              currentPlaying.pause();
              currentPlaying.currentTime = 0; // 再生位置リセット
            }
  
            // 新しい動画を再生
            video.play().catch(error => {
              console.warn('再生エラー:', error);
            });
  
            currentPlaying = video;
          }
        }
      });
    });
  });

// よくあるご質問アコーディオンメニュー
document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.qa');

  accordionItems.forEach(item => {
    const header = item.querySelector('dt'); 
    const content = item.querySelector('dd'); 

    header.addEventListener('click', () => {
      // アイテム全体に open クラスを切り替え
      item.classList.toggle('open');

      // スライドの開閉処理
      if (content.style.maxHeight) {
        // 開いている場合は閉じる
        content.style.maxHeight = null;
      } else {
        // 必要な高さを計算して設定
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});

$(function() {

  // 商品詳細
  if($('.template-product').length) {
    processingImageArrowButton();
    imagelistModal();
    baggageSizeSelectContent();
  }

});

/*
 * 商品画像の矢印ボタンの処理
 */
function processingImageArrowButton() {
  //商品画像が2枚以上の場合
  if ($('.product-single__media-wrapper').length >= 2) {
    //前へ、次へボタンを表示
    $('.product-single__media-group').prepend('<div class="customize-prev-btn"></div>');
    $('.product-single__media-group').append('<div class="customize-next-btn"></div>');
    //それ以外の場合、処理終了
  } else {
    return false;
  }
  //動作
  var activeIndex;
  //「＜」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-prev-btn", function() {
    //カレント画像が何番目かを取得
    activeIndex = $('.active-thumb').index('.product-single__thumbnail--product-template');
    //一枚目の場合
    if (activeIndex == 0) {
      //処理終了
      return false;
    }
    //ひとつ前の画像を表示
    document.getElementsByClassName("product-single__thumbnail--product-template")[activeIndex - 1].dispatchEvent(new Event('click', {cancelable: true}));
  });
  //「＞」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-next-btn", function() {
    //カレント画像が何番目かを取得
    activeIndex = $('.active-thumb').index('.product-single__thumbnail--product-template');
    //最後の画像の場合、処理終了
    if (activeIndex == $('.product-single__thumbnail--product-template').length - 1) {
      return false;
    }
    //ひとつ後の画像を表示
    document.getElementsByClassName("product-single__thumbnail--product-template")[activeIndex + 1].dispatchEvent(new Event('click', {cancelable: true}));
  });
}

/* 商品画像一覧のモーダル */
function imagelistModal() {
  var modalOpen = $('.js-imagelist-btn');
  var modalContents = $('.js-modal-imagelist');
  var modalClose = $('.js-imagelist-close');
  modalOpen.on('click', function(){
    modalContents.addClass('is-active');
  });
  modalClose.on('click', function(){
    modalContents.removeClass('is-active');
  });
}


/* 商品ページ　機内持ち込み手荷物サイズ プルダウン */
function baggageSizeSelectContent() {
  if (document.getElementById('product-baggagesize-select-menu')) {
    var baggageSizeSelect = document.getElementById('product-baggagesize-select-menu');
    baggageSizeSelect.addEventListener('change', function() {
      var baggageSizeContent = document.getElementsByClassName('product-baggagesize-select-content-item');
      var baggageSizeContentVal = this.value;
      for (var i = 0; i < baggageSizeContent.length; i++) {
        baggageSizeContent[i].style.display = (i === parseInt(baggageSizeContentVal)) ? 'block' : 'none';
      }
    });
  }
}

